require("!!/Users/matthias.koll/Projects/editel-website/node_modules/script-loader/addScript.js")(require("!!/Users/matthias.koll/Projects/editel-website/node_modules/raw-loader/index.js!/Users/matthias.koll/Projects/editel-website/node_modules/fontfaceobserver/fontfaceobserver.standalone.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./node_modules/fontfaceobserver/fontfaceobserver.standalone.js
// module id = 161
// module chunks = 6